module.exports = __webpack_public_path__ + "static/media/bored-and-free.2014485f.jpg";